import { Component, ViewEncapsulation, OnInit, OnDestroy, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, RouterState, Router } from '@angular/router';
import { PhotoService } from '../_services/photo.service';
import { Subscription, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Photo } from '../_models/Photo';
import { DialogService } from '../_services/dialog.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { mergeMap } from 'rxjs/operators'
import { Environment } from '../../environments/environment';

@Component({
  templateUrl: './selfie-cam-view.component.html',
  styleUrls: ['./selfie-cam-view.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SelfieCamViewComponent implements OnInit, OnDestroy {
  selfieCamPhotos: Photo[];
  photosToShow: Photo[] = [];

  photos$: Subscription;
  delete$: Subscription;

  loading = true;

  selfieCamId: number;
  serviceId: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private photoService: PhotoService,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.photos$ = this.loadPhotos().subscribe();
  }

  deletePhoto(photoId: number) {
    this.dialogService.confirm('Confirm Delete', 'Are you sure you want to delete this photo?', this.viewRef).then(result => {
      if (result) {
        this.loading = true;
        this.spinner.show();
        this.delete$ = this.photoService
          .deleteSelfieCamPhoto(photoId)
          .pipe(
            tap(
              () => {
                this.loading = false;
                this.spinner.hide();
              },
              () => {
                this.loading = false;
                this.spinner.hide();
                this.dialogService.alert('Error', 'Unable to delete photo', this.viewRef);
              }
            ),
            mergeMap(() => this.loadPhotos())
          ).subscribe();
      }
    });
  }

  private loadPhotos(): Observable<any> {
    this.loading = true;
    this.spinner.show();
    this.photosToShow = [];

    return this.route.params.pipe(
      tap(params => {
        this.selfieCamId = +params['id'];
        this.serviceId  = +params['serviceId'];
        this.photoService.getSelfieCamPhotos(this.selfieCamId).pipe(
          tap(photos => {

            // transform the s3 url format to https
            photos.map(p => {
              const s = p.url.split('/');
              if (s && s[0] === 's3:') {
                p.url = Environment.s3CdnUrl + "/" + s.slice(3).join('/');
              }
            });

            this.selfieCamPhotos = photos;

            this.photosToShow = photos;
            this.loading = false;
            this.spinner.hide();
          },
            () => {
              this.dialogService.alert('Error', 'Unable to load photos', this.viewRef);
              this.loading = false;
              this.spinner.hide();
            }
          )
        ).subscribe();
      }
      )
    );
  }

  onScroll() {
    if (this.selfieCamPhotos && this.selfieCamPhotos.length > 0) {
      let photosToAdd: Photo[], index: number;

      index = this.photosToShow.length;
      photosToAdd = this.selfieCamPhotos.slice(index, index + 9);
      this.photosToShow = this.photosToShow.concat(photosToAdd);
    }
  }

  return() {
    this.router.navigate(['../../../',  this.serviceId, this.selfieCamId], {relativeTo: this.route});
  }

  ngOnDestroy() {
    if (this.photos$) {
      this.photos$.unsubscribe();
    }

    if (this.delete$) {
      this.delete$.unsubscribe();
    }
  }
}
